import { useEffect, useState } from "react";
import api from "@/lib/api";
import PlotCard from "@/components/PlotCard";
import LeadForm from "@/components/LeadForm";

const FILTERS = ["all", "available", "reserved", "sold"];

export default function Projects() {
  const [plots, setPlots] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/plots", { params: filter === "all" ? {} : { status: filter } })
      .then((r) => setPlots(r.data))
      .catch(() => setPlots([]))
      .finally(() => setLoading(false));
  }, [filter]);

  return (
    <div className="bg-[#0a0a0b] text-white pt-32">
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16" data-testid="projects-hero">
        <p className="label-overline">Inaugural Layout · Launching Soon</p>
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mt-4">
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[1.05] max-w-3xl">
            Inaugural plots <br /><span className="italic text-[#c5a059]">in Shujalpur</span>.
          </h1>
          <div className="flex gap-2 flex-wrap" data-testid="projects-filters">
            {FILTERS.map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                data-testid={`filter-${f}`}
                className={`px-4 py-2 rounded-full text-xs tracking-[0.2em] uppercase border transition ${
                  filter === f
                    ? "border-[#c5a059] text-[#c5a059] bg-[#c5a059]/5"
                    : "border-[#2a2a2d] text-[#8f8f94] hover:text-white hover:border-[#3a3a3d]"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>
        <p className="text-[#8f8f94] text-sm mt-6 max-w-2xl">
          Indicative plot configurations for our debut layout. Pricing and bookings will be
          announced at launch — register your details below to be notified.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-12 pb-24">
        {loading ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="aspect-[4/3] bg-[#121214] border border-[#1f1f22] rounded-xl animate-pulse" />
            ))}
          </div>
        ) : plots.length === 0 ? (
          <p className="text-[#8f8f94] py-20 text-center">No plots match this filter.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="plots-grid">
            {plots.map((p) => (
              <PlotCard key={p.id} plot={p} />
            ))}
          </div>
        )}
      </section>

      <section className="bg-[#08080a] border-t border-[#1f1f22] py-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <LeadForm />
        </div>
      </section>
    </div>
  );
}
